<template>
  <m-dialog ref="dlg" title="Reset Konfigurasi" :btnsave="false">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th width="20">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-checkbox v-model="isSelected" :falseValue="0" :trueValue="1">
                    <template v-slot:append>
                      <v-icon v-on="on">mdi-dots-vertical</v-icon>
                    </template>
                  </v-checkbox>
                </template>
                <v-list>
                  <v-list-item @click="onSetAkses(1)">
                    <v-list-item-title>Set {{ key }} menjadi 1</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="onSetAkses(0)">
                    <v-list-item-title>Set {{ key }} menjadi 0</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </th>
            <th class="text-left"> Nama </th>
            <th class="text-left"> Organisasi ID </th>
            <th class="text-left"> Status </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="items.length">
            <tr v-for="(item, i) in items" :key="i">
              <td :class="item.id === null ? 'red lighten-5' : ''">
                <v-checkbox v-model="selected[Number(item.organisasi_id)]" :falseValue="0" :trueValue="1" />
              </td>
              <td :class="item.id === null ? 'red lighten-5' : ''">
                {{ item.nama || '' }}
              </td>
              <td :class="item.id === null ? 'red lighten-5' : ''">
                {{ item.no_reg || '' }}
              </td>
              <td :class="item.id === null ? 'red lighten-5' : ''">
                {{ key }}:
                {{ findStatus(item) }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="4">Belum ada data ditemukan</td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </m-dialog>
</template>
<script>
export default {
  data() {
    return {
      key: null,
      tenant_id: null,
      items: [],
      total: 0,
      selected: {},
      isSelected: 0,
    }
  },

  methods: {
    fetchData() {
      this.items = []
      this.$store
        .dispatch('akses/getCfg', { tenant_id: this.tenant_id, key: this.key, count: this.total })
        .then(({ data }) => {
          const items = (data && data.data) || []

          items.forEach((item) => {
            const konfigurasis = (item.konfigurasis || []).find((fils) => fils.key === this.key) || {}
            if (Object.keys(konfigurasis).length) {
              this.items.push(item)
            }
          })

          this.$refs.dlg.open()
        })
        .catch((e) => e)
    },

    open(props) {
      if (!props.tenant_id || !props.key) return
      this.$set(this, 'tenant_id', props.tenant_id)
      this.$set(this, 'key', props.key)
      this.$set(this, 'total', props.total)
      this.reset();
      this.fetchData()
    },

    reset() {
      this.selected = {}
      this.isSelected = 0
      this.items = []
    },

    findStatus(item) {
      const find = (item.konfigurasis || []).find((fill) => fill.key === this.key) || {}
      if (Object.keys(find).length) {
        return find.value
      } else {
        return 'Belum Diset'
      }
    },

    onSetAkses(akses) {
      let orgId = []
      Object.keys(this.selected).forEach((key) => {
        if (this.selected[key] === 1) {
          orgId.push(key)
        }
      })

      if (orgId.length === 0){
        this.$error('Harap Pilih Organisasi')
      } else {
        this.$store
          .dispatch('akses/saveCfg', {
            key: this.key,
            value: akses,
            organisasi_ids: orgId,
          })
          .then(() => {
            this.$success('Konfigurasi berhasil di perbarui')
            this.$emit('reload')
            this.$refs.dlg.resolve()
          })
      }
    },
  },

  watch: {
    isSelected(s) {
      if (s === 0) {
        this.selected = {}
      } else if (s === 1) {
        this.items.forEach((item) => {
          this.$set(this.selected, item.organisasi_id.toString(), 1)
        })
      }
    },
  },
}
</script>
